// Mock data for Jeevan Utsav Wedding Website

export const packages = [
  {
    id: 1,
    name: "Silver Package",
    guests: "40-50 Guests",
    duration: "2 Nights / 3 Days",
    originalPrice: "",
    discountedPrice: "2,99,999",
    discount: "",
    features: [
      "Venue with Ganges accessibility",
      "Vegetarian 3 time meals",
      "Basic light decor",
      "Basic sound system",
      "Accommodation for 50 guests",
      "Big size halls & lawns",
      "Phera ceremony in big size yagshala",
      "Traditional Ganga Aarti arrangement"
    ],
    image: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/x4j3q3qu_WhatsApp%20Image%202026-02-15%20at%2023.08.05%20%282%29.jpeg",
    popular: false
  },
  {
    id: 2,
    name: "Gold Package",
    guests: "80-100 Guests",
    duration: "2 Nights / 3 Days",
    originalPrice: "",
    discountedPrice: "6,99,999",
    discount: "",
    features: [
      "Everything in Silver Package",
      "Upgraded premium floral decor",
      "Professional DJ and sound system",
      "Dedicated wedding coordinator",
      "Accommodation for 80-100 guests",
      "Mehendi and Sangeet setup",
      "Decorative lighting and stage setup",
      "Welcome gift hampers for guests",
      "Welcome drinks and snacks"
    ],
    image: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/sp5rrkq5_WhatsApp%20Image%202026-02-15%20at%2023.08.06.jpeg",
    popular: true
  },
  {
    id: 3,
    name: "Platinum Package",
    guests: "125-150 Guests",
    duration: "2 Nights / 3 Days",
    originalPrice: "",
    discountedPrice: "9,99,999",
    discount: "",
    features: [
      "Everything in Gold Package",
      "Full resort buyout options",
      "Premium multi-cuisine catering (Indian, Continental, Chinese)",
      "Luxury decor themes (Boho, Royal, Floral)",
      "Live music and entertainment",
      "Accommodation for 120-150 guests",
      "Customized mandap design",
      "Guest activities (yoga, trekking, spa)"
    ],
    image: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/va930faf_WhatsApp%20Image%202026-02-15%20at%2023.08.03.jpeg",
    popular: false
  }
];

export const services = [
  {
    id: 1,
    title: "Riverside Pheras",
    description: "Exchange vows with the sacred Ganges as your witness. The gentle sound of flowing water and mountain breeze create an unforgettable spiritual ambiance.",
    icon: "Waves",
    image: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/9h3a3rtc_WhatsApp%20Image%202026-02-15%20at%2023.07.57.jpeg"
  },
  {
    id: 2,
    title: "Custom Decor",
    description: "Blend traditional marigolds with bohemian-Himalayan themes. Our local artisans craft unique setups with bells, diyas, and natural elements.",
    icon: "Sparkles",
    image: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/va930faf_WhatsApp%20Image%202026-02-15%20at%2023.08.03.jpeg"
  },
  {
    id: 3,
    title: "Ganga Aarti Experience",
    description: "Treat your guests to the mesmerizing evening Ganga Aarti ceremony. A spiritual experience they'll cherish forever.",
    icon: "Flame",
    image: "https://images.unsplash.com/photo-1764173517657-0e7d94d94a4b?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Wellness Activities",
    description: "Morning yoga sessions, guided treks, and meditation by the Ganges. Perfect for mindful celebrations.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1758274534291-633ab603ec4d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
  }
];

export const gallery = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/2eh1nrux_WhatsApp%20Image%202026-02-15%20at%2023.08.06%20%281%29.jpeg",
    alt: "Decorated Wedding Stage with Colorful Drapes"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/sp5rrkq5_WhatsApp%20Image%202026-02-15%20at%2023.08.06.jpeg",
    alt: "Outdoor Seating with Fairy Lights"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/9h3a3rtc_WhatsApp%20Image%202026-02-15%20at%2023.07.57.jpeg",
    alt: "Floral Arch by Riverside"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/va930faf_WhatsApp%20Image%202026-02-15%20at%2023.08.03.jpeg",
    alt: "Colorful Venue with Gazebo"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/o82p9hs0_WhatsApp%20Image%202026-02-15%20at%2023.07.58.jpeg",
    alt: "Haldi Ceremony Setup"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/gqr4l4zx_WhatsApp%20Image%202026-02-15%20at%2023.07.59.jpeg",
    alt: "Evening Venue with Fairy Lights"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/715pbwt1_WhatsApp%20Image%202026-02-15%20at%2023.08.03%20%281%29.jpeg",
    alt: "Daytime Colorful Seating Setup"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/atkz6pmm_WhatsApp%20Image%202026-02-15%20at%2023.08.04.jpeg",
    alt: "Elegant Candle Holder Backdrop"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_d81054eb-3f63-4be1-8482-0ec2893ad2a4/artifacts/e29yjgl6_WhatsApp%20Image%202026-02-15%20at%2023.08.04%20%281%29.jpeg",
    alt: "Green Lit Entrance Pathway"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya & Arjun Mehta",
    location: "Mumbai",
    text: "Jeevan Utsav Retreat gave us the wedding of our dreams at a price we could actually afford. The riverside ceremony was magical, and the team handled everything beautifully. Our Gold package was perfect for our 90 guests!",
    rating: 5,
    weddingDate: "December 2024",
    image: "https://images.unsplash.com/photo-1574017121722-2c8ead5a7e90"
  },
  {
    id: 2,
    name: "Rahul & Sneha Kapoor",
    location: "Delhi",
    text: "The Platinum package exceeded all expectations. From the Ganga Aarti to the customized mandap, every detail was perfect. Our 140 guests are still talking about the beautiful venue and amazing food!",
    rating: 5,
    weddingDate: "February 2025",
    image: "https://images.unsplash.com/photo-1767653431683-9d8346bc18f3"
  },
  {
    id: 3,
    name: "Ananya & Karthik Reddy",
    location: "Bangalore",
    text: "The Silver package was ideal for our intimate 45-guest wedding. The team's local expertise and the serene Ganges setting made it unforgettable. Best value for money in Rishikesh!",
    rating: 5,
    weddingDate: "November 2024",
    image: "https://images.unsplash.com/photo-1683318528842-bd5f1fd0ff9a"
  }
];

export const whyUs = [
  {
    id: 1,
    title: "Best Price Guarantee",
    description: "We offer Rishikesh's most competitive rates without compromising on quality. Best value, guaranteed.",
    icon: "Handshake"
  },
  {
    id: 2,
    title: "Born in Rishikesh",
    description: "Local expertise from artisans, priests, and vendors who know the land and its spiritual essence.",
    icon: "MapPin"
  },
  {
    id: 3,
    title: "Transparent Pricing",
    description: "No hidden costs or 'tourist prices'. What you see is what you pay. Every rupee accounted for.",
    icon: "Receipt"
  },
  {
    id: 4,
    title: "Mindful Celebrations",
    description: "Unique wellness experiences - yoga, meditation, and spiritual journeys for you and your guests.",
    icon: "Lotus"
  }
];

export const taglines = [
  "Divine Unions, Best Prices in Rishikesh",
  "Where Sacred Ganges Meets Unbeatable Value",
  "Spiritual Grandeur, Rishikesh's Best Rates",
  "Blessed by the Ganges, Best Price Guaranteed",
  "Premium Weddings, Rishikesh's Lowest Prices"
];

export const stats = [
  { label: "Happy Couples", value: "150+", icon: "Heart" },
  { label: "Best Prices", value: "#1", icon: "TrendingDown" },
  { label: "Years Experience", value: "8+", icon: "Award" },
  { label: "Guest Satisfaction", value: "98%", icon: "Star" }
];
